// removed by extract-text-webpack-plugin
module.exports = {"postContainer":"dashboard__postContainer__1j7-f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dashboard/dashboard.css
// module id = 848
// module chunks = 0